var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#56C02B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88781 5.50613C3.93059 5.64184 4.13443 7.54335 5.08682 8.08472C4.28202 9.34837 5.08078 10.5461 6.0441 10.5461H9.18946C10.9208 10.5461 12.1374 7.60746 9.43367 6.39497C10.4201 2.97713 5.85956 3.20832 5.88781 5.50613Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3284 9.16948C13.2061 8.76243 14.2763 9.66676 14.2763 9.66676C14.2763 9.66676 15.1937 8.81295 16.1964 9.18329C16.4543 9.27854 16.4346 9.01037 16.3484 8.94847C15.8367 8.58087 15.1957 8.22668 14.3039 8.93467C13.2263 8.24525 12.6295 8.55797 12.2041 8.93467C12.0925 9.03347 12.1315 9.2608 12.3284 9.16948Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9949 6.00747C11.6887 5.60836 12.6363 6.27604 12.6363 6.27604C12.6363 6.27604 13.3304 5.50583 14.1837 5.73833C14.4031 5.79812 14.3674 5.57855 14.2919 5.53379C13.8435 5.26795 13.2895 5.02253 12.6059 5.67068C11.6679 5.18065 11.1987 5.48167 10.8754 5.82297C10.7906 5.9125 10.8393 6.09702 10.9949 6.00747V6.00747Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.511 4.10226C14.1481 4.00819 14.6603 4.78743 14.6603 4.78743C14.6603 4.78743 15.4071 4.41573 15.9772 4.84144C16.1238 4.95093 16.1618 4.77603 16.1185 4.72025C15.8613 4.38901 15.5191 4.04192 14.8162 4.32539C14.2587 3.68192 13.8187 3.76882 13.476 3.92892C13.3862 3.97091 13.3681 4.12337 13.511 4.10226V4.10226Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58316 11.0371H8.23579C8.31614 11.0371 8.38084 11.1018 8.38084 11.1821V12.9211C8.38084 13.0014 8.31614 13.0661 8.23579 13.0661H7.58316C7.5028 13.0661 7.43811 13.0014 7.43811 12.9211V11.1821C7.43811 11.1018 7.5028 11.0371 7.58316 11.0371Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14505 13.8489H16.5795C16.6599 13.8489 16.7246 13.9136 16.7246 13.9939V14.6124C16.7246 14.6928 16.6599 14.7575 16.5795 14.7575H4.14505C4.06469 14.7575 4 14.6928 4 14.6124V13.9939C4 13.9136 4.06469 13.8489 4.14505 13.8489Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14505 15.3408H16.5795C16.6599 15.3408 16.7246 15.4055 16.7246 15.4859V16.1044C16.7246 16.1847 16.6599 16.2494 16.5795 16.2494H4.14505C4.06469 16.2494 4 16.1847 4 16.1044V15.4859C4 15.4055 4.06469 15.3408 4.14505 15.3408Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.187827fb050038edb24609209ab52b0b.svg";
export { ForwardRef as ReactComponent };